import {get, post, patch, del} from './http';

export type QaConfig = {
  id: string;
  policy_violation: string;
  sample_percent: number;
  population_size: number;
  calculated_sample_size: number;
  schedule: string;
  next_run_at: string | null;
  weekly_occurrences: number;
  last_fired_at: string | null;
  enabled: boolean;
  created_by: string;
  created_at: string;
  modified_by: string | null;
  modified_at: string | null;
};

export type CreateQaConfigPayload = {
  policy_violation: string;
  sample_percent: number;
  schedule: string;
  enabled?: boolean;
};

export type UpdateQaConfigPayload = {
  policy_violation?: string;
  sample_percent?: number;
  schedule?: string;
  enabled?: boolean;
};

export type FireQaConfigResult = {
  selected: number;
  population_size: number;
  submission_ids: string[];
};

/** A one-off window, `[from, to)` as ISO instants. Omitted, the config's own since-last-fired window is sampled. */
export type FireQaConfigRange = {
  from: string;
  to: string;
};

export const qaConfigsApi = {
  list: async () => get<QaConfig[]>('/qa-configs'),
  create: async (payload: CreateQaConfigPayload) =>
    post<CreateQaConfigPayload, QaConfig>('/qa-configs', payload),
  update: async (id: string, payload: UpdateQaConfigPayload) =>
    patch<UpdateQaConfigPayload, QaConfig>(`/qa-configs/${id}`, payload),
  delete: async (id: string) => del(`/qa-configs/${id}`),
  fire: async (id: string, range?: FireQaConfigRange) =>
    post<FireQaConfigRange | Record<string, never>, FireQaConfigResult>(
      `/qa-configs/${id}/fire`,
      range ?? {}
    )
};
